import type { Station } from '@protector/entities/station/models';
import type { AccordionGroupProps } from 'components/sidebar-accordion/sidebar-accordion.models';

export const filterStaticPointsByFields = ({
  listOfFields,
  listOfStations,
  templateGroup
}: {
  listOfFields: string[];
  listOfStations: Station[];
  templateGroup?: AccordionGroupProps;
}): Station[] => {
  const fieldIdsSet = new Set(listOfFields);
  let filteredStations = listOfStations.filter(station => station.areas_ids?.some(fieldId => fieldIdsSet.has(fieldId)));
  if (templateGroup) {
    filteredStations = filteredStations.filter(station => station.template_id === templateGroup.id);
  }
  return filteredStations;
};
